import { Dialog } from '@/components/UI/Dialog'
import { IconLock } from '@tabler/icons-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  /** storybookで確認する際に、スクロール可にするためのフラグ。raundで利用する場合にはtrue */
  scrollLock?: boolean
}

/**
 * 音声ガイドが有効範囲外のためロックされている状態を表示するダイアログ。
 * 有効範囲外のユーザーが音声ガイドボタンをタップした場合に表示する。
 */
export const DialogAudioGuideLocked = memo(({ onClose, scrollLock = false }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={true} compact showCloseButton={false} lockScroll={scrollLock} closeAction={onClose}>
      <div className="flex flex-col items-center gap-[16px] py-[8px]">
        <div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[#f5f5f5]">
          <IconLock size={32} className="text-[#757575]" />
        </div>

        <p className="text-center text-[14px] font-bold text-black leading-[22px]">
          {t('spot_detail.audio_guide.out_of_range_message', '音声ガイドは\n有効範囲内に\nご利用いただけます。')}
        </p>

        <button
          type="button"
          onClick={onClose}
          className="h-[36px] w-[254px] rounded-[8px] text-[13px] font-bold bg-white border border-[#757575] text-[#757575]"
        >
          {t('common.close', '閉じる')}
        </button>
      </div>
    </Dialog>
  )
})

DialogAudioGuideLocked.displayName = 'DialogAudioGuideLocked'
